<template>
    <div>
        <a-modal title="添加菜单" :visible="menuModalStatus.isShow" :confirm-loading="confirmLoading" @ok="handleOk"
                 @cancel="handleCancel">
            <a-form-model ref="ruleForm" :model="form" layout="inline" v-on:keyup.enter="handleOk" :rules="rules">
                <a-form-model-item label="配置名(appcode)" style="width: 35%" prop="name">
                    <a-input v-model="form.name"/>
                </a-form-model-item>
                <a-form-model-item label="配置值(url)" style="width: 45%">
                    <a-input v-model="form.value" v-on:keyup.enter="handleOk"/>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            confirmLoading: false,
            form: {
                name: '',
                value: ''
            },
            rules: {
                name: [
                    {required: true, message: '请输入子平台编码', trigger: 'blur'},
                    {min: 1, max: 100, message: '配置名称长度 1 ~ 100', trigger: 'blur'},
                ],
                value: [
                    {required: true, message: '请输入配置值', trigger: 'blur'},

                ]
            }
        }
    },
    props: {
        menuModalStatus: {
            isShow: false,
        }
    },
    methods: {
        handleOk() {
            let that = this;
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    console.log(that.form.value)
                    if (that.form.value == null || that.form.value == "") {
                        that.message.error("值不能为空");
                    } else {
                        that.$emit('onModalHide', that.form);
                        that.form.name = '';
                        that.form.value = '';
                    }

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleCancel() {
            this.$emit('onModalHide', null);

        },
    },
};
</script>
